// extracted by mini-css-extract-plugin
module.exports = {"app-middle":"middle_app-middle__3zlHS","middle-title":"middle_middle-title__1xKYc","images-block":"middle_images-block__2j1pO","image-block":"middle_image-block__3gxDw"};